<template>

        <div>
            <div class="charts">
                <div>
                    <Chart :list="list" />
                </div>
                <div>
                    <Chart2 :list="list" />
                </div>
            </div>
<!--            <a-select :allowClear="false" v-model="activeIndex">-->
<!--                <a-select-option v-for="(item, index) in list" :key="index">{{ item.month }}</a-select-option>-->
<!--            </a-select>-->
            <SelectField
                :modelValue="activeIndex"
                labelWidth="0"
                style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;"
                :options="selectOptions"
                placeholder="选择月份"
                id="activeIndex"
                @update:modelValue="(value) => handleModelValueUpdate('activeIndex', value)"
            />
            <div style="padding-top: 2vh;"></div>
            <Tablelist style="margin-top: 1rem" :showCheckbox="false" :list="filteredList" :columns="tableColumns" />
        </div>
</template>
<script>
import { fetchData } from "../api/analysis";

import Chart from './chart.vue'
import Chart2 from "./chart2.vue";
export default {

  components: {
      Chart,Chart2,
  },
  data() {
    return {
      list: [],
      loading: false,
      activeIndex: 0,
      tableColumns: [
        {
            key: 'code',
            title: '批次编号',
            field: 'code',
            infotype: 'text'
        },
        {
            key: 'name',
            title: '资产名称',
            field: 'name',
            infotype: 'text',
        },
        {
            key: 'brand',
            title: '品牌',
            field: 'brand',
            infotype: 'text',
        },
        {
           key: 'number',
           title: '数量',
           field: 'number',
           infotype: 'text',
        },
        {
            key: 'specification',
            title: '规格型号',
            field: 'specification',
            infotype: 'text',
        },
        {
            key: 'unit',
            title: '单位',
            field: 'unit',
            infotype: 'text',
        },
        {
              key: 'price',
              title: '单价(元)',
              field: 'price',
              infotype: 'text',
        },
        {
              key: 'priceTotal',
              title: '总价(元)',
              field: 'priceTotal',
              infotype: 'text',
        },
        {
              key: 'createAt',
              title: '批次采购申请时间',
              field: 'createAt',
              infotype: 'text',
        }
    ],
    };
  },
    computed: {
        selectOptions() {
            return this.list.map((item, index) => ({
                value: index,
                name: item.month || `Month ${index + 1}`
            }));
        },
        filteredList() {
            const item = this.list[this.activeIndex];
            return item && Array.isArray(item.list) ? item.list : [];
        }
    },
    mounted() {
        this.loading = true;
        fetchData().then((res) => {
            console.log('res', res);
            if (Array.isArray(res)) {
                this.list = Object.freeze(res);
                this.setActiveIndexToCurrentMonth();
            } else {
                this.list = [];
                this.activeIndex = null;
            }
        }).catch((err) => {
            console.error('Error fetching data:', err);
        }).finally(() => {
            this.loading = false;
        });
    },
    methods:{
        setActiveIndexToCurrentMonth() {
            const currentMonth = new Date().getMonth();
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const currentMonthName = monthNames[currentMonth];

            const index = this.list.findIndex(item => item.month === currentMonthName);
            this.activeIndex = index !== -1 ? index : 0;
        },
        handleModelValueUpdate(fieldName, value) {
            if (fieldName === 'activeIndex') {
                this.activeIndex = value;
            }
        },
    }
};
</script>

<style lang="less" scoped>
.charts {
  margin-bottom: 1vh;
  display: flex;

  &>div {
    flex: 1;
  }
}
</style>